import { TrashIcon } from "@cynthai/icons";
import { twMerge } from "tailwind-merge";

import Button from "./Button";
import { useModal } from "./hooks/use-modal";
import DeleteModal from "./modals/DeleteModal";
import { m } from "./paraglide/messages";

type DeleteSelectionButtonProps = {
  onDelete: () => void | Promise<void>;
  title?: string;
  description?: string;
  children?: string;
  className?: string;
};

export default function DeleteSelectionButton({
  onDelete,
  title = m.delete_warning(),
  description = m.delete_warning_description(),
  children = m.delete_selection(),
  className,
}: Readonly<DeleteSelectionButtonProps>) {
  const deleteModal = useModal({
    modal: DeleteModal,
  });

  return (
    <Button
      color="danger"
      variant="ghost"
      className={twMerge("h-12 font-normal", className)}
      size="sm"
      onPress={() => {
        void deleteModal.show({
          title,
          description,
          onDelete,
        });
      }}
      type="button"
    >
      <TrashIcon width={20} height={20} />
      {children}
    </Button>
  );
}
